Login from ./login.civet
type { LoginOptions } from ./login.civet

export login := (options: Omit<LoginOptions, "resolve" | "reject">) ->
  new Promise (resolve, reject) ->
    Login {
      ...options
      resolve
      reject
    }

export Login
